module.exports = __webpack_public_path__ + "img/reset.a12bb1ad.svg";